import React from "react";
import { Skeleton } from "@progress/kendo-react-indicators";
import { Card, CardBody } from "@progress/kendo-react-layout";
import "./skeletonStyles.scss";

const SkeletonDocumentViewer = () => {
  return (
    <div className="row mt-2 skeletonDocumentViewer">
      <div className="col-4">
        <Card>
          <CardBody className="card-50">
            <Skeleton shape={"rectangle"} className="skeleton-box mb-2" />
            <Skeleton shape={"rectangle"} className="skeleton-box mb-2" />
            <Skeleton shape={"rectangle"} className="skeleton-box mb-2" />
            <Skeleton shape={"rectangle"} className="skeleton-box" />
          </CardBody>
        </Card>
      </div>
      <div className="col-8">
        <div className="row mb-2">
          <div className="col-4">
            <Skeleton shape={"text"} />
          </div>
          <div className="col-4"></div>
          <div className="col-4 inline">
            <Skeleton shape={"circle"} className="skeleton-icons mr-1" />
            <Skeleton shape={"circle"} className="skeleton-icons mr-1" />
            <Skeleton shape={"circle"} className="skeleton-icons mr-1" />
            <Skeleton shape={"circle"} className="skeleton-icons mr-1" />
          </div>
        </div>
        <Skeleton shape={"rectangle"} className="skeleton-preview-box" />
      </div>
    </div>
  );
};

export default SkeletonDocumentViewer;
